module.exports = __webpack_public_path__ + "img/undone.b2c39bff.png";